import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BaseModalComponent } from "@ha/ui/common";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { PushNotificationStatus } from "../../models/push-notification-status.enum";
import { PushNotification } from "../../models/push-notification.model";
import { PushNotificationActions } from "../../states/push-notification.actions";
import { PushNotificationSelectors } from "../../states/push-notification.selectors";

@Component({
    templateUrl: "./unread-notifications-modal.component.html",
    styleUrls: ["./unread-notifications-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnreadNotificationsModalComponent extends BaseModalComponent {
    @Select(PushNotificationSelectors.unreadNotifications)
    public notifications$: Observable<PushNotification[]>;

    public PushNotificationStatus = PushNotificationStatus;

    constructor(private store: Store) {
        super();
    }

    public markAllAsRead(): void {
        this.store.dispatch(new PushNotificationActions.MarkAllAsRead());
    }

    public onNotificationClick(notification: PushNotification): void {
        // Mark as read
        this.store.dispatch(
            new PushNotificationActions.SetNotificationStatus(notification.notificationId, PushNotificationStatus.Read),
        );

        // Navigate to URL if available
        if (notification.url) {
            window.location.href = notification.url;
        }

        // Close modal
        this.closeModal();
    }
}



